export default __webpack_public_path__ + "static/media/install2.23bba08a.webp";